import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { PerPersonnelService } from '../../service/per-personnel-service';
import { PerPersonnelSearchModel } from '../../model/hr-per-personnel-search-model';
import { PerPersonnelSearchQueryModel } from '../../model/hr-per-personnel-search-query-model';
import { Subscription } from 'rxjs';
import { HvlAbstractLazyList } from '@hvlng/framework-core/form';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AutoComplete } from 'primeng/autocomplete';
import {HvlConfigurationService} from "@hvlng/framework-bff/core";
import { PersonnelSharedService } from '../../../../service/personnel-shared-service';

@Component({
    selector: 'hr-per-personnel-search',
    templateUrl: './hr-per-personnel-search.component.html',
    styleUrls: ['./hr-per-personnel-search.component.scss'],
})
export class HrPerPersonnelSearchComponent
    extends HvlAbstractLazyList<PerPersonnelSearchModel>
    implements OnInit, OnDestroy {
    @ViewChild('personnelAutoComplete') personnelAutoComplete: AutoComplete;
    selectedLang=this.configurationService.config.theme.language.system
    private _selectedItem: any;
    @Input() isReadOnly = false;
    @Input() set selectedItem(val: any) {
        if (val === this._selectedItem) return;
        this._selectedItem = val;
        this.setFormControlsBySelectedItem();
    }
    get selectedItem(): any {
        return this._selectedItem;
    }

    private _isDisabled: boolean = false;
    @Input() set isDisabled(val: boolean) {
        if (val === this._isDisabled) return;
        this._isDisabled = val;
        this.setFormControlsByDisabled();
    }

    get isDisabled(): boolean {
        return this._isDisabled;
    }
    @Input() appendTo: string;
    @Input() placeHolder: string = '';
    @Input() isPictureVisible: boolean = true;
    @Input() minSearchLength: number = 3;
    @Input() showEmptyMessage: boolean = true;
    @Input() emptyMessage: string = '';
    @Input() queryModel: PerPersonnelSearchQueryModel = new PerPersonnelSearchQueryModel();
    @Input() showClear: Boolean=false;

    @Output() valueEvent = new EventEmitter<any>();

    form: FormGroup;
    list: any[];
    private subscription: Subscription;

    constructor(
        private formBuilder: FormBuilder,
        private perPersonnelService: PerPersonnelService,
        protected searchPersonnelQueryHandler: PersonnelSharedService,
        protected configurationService:HvlConfigurationService
    ) {
        super();
        this.form = this.formBuilder.group({
            searchText: [
                {
                    value: this.getPerSummaryByModel(this.selectedItem),
                    disabled: this.isDisabled,
                },
            ],
        });
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

    onSearch(event: any) {
        if (event.query) {
            event.query = event.query.toLocaleUpperCase(this.selectedLang.code)
        }
        this.queryModel.searchParam = event.query;
        this.subscription = this.searchPersonnelQueryHandler.searchPersonnelQueryList(this.queryModel)
            .subscribe((data) => {
                if (this.isPictureVisible) {
                    data.forEach((d) => {
                        if (d.pictureUuid) {
                            d.pictureSource = this.perPersonnelService.getPictureUrl(d.hrmPerPeopleId);
                        }
                    });
                }
                this.list = data;
            });
    }

    onSelect(event: any) {
        this.selectedItem = event;
        this.valueEvent.emit(this.selectedItem);
    }

    onClear() {
        this.selectedItem = null;
        this.valueEvent.emit(null);
    }

    resetForm() {
        this.form.reset();
    }

    changeSelectedItem(model: any) {
        this.selectedItem = model;
    }

    clearSelectedItem() {
        this.selectedItem = null;
    }

    changeIsDisabled(val: boolean) {
        this.isDisabled = val;
    }

    private setFormControlsBySelectedItem() {
        if (!this.form) return;
        this.form.controls['searchText'].patchValue(this.getPerSummaryByModel(this.selectedItem));
    }

    private setFormControlsByDisabled() {
        if (!this.form) return;
        this.form.controls.searchText[this.isDisabled ? 'disable' : 'enable']();
    }

    getPerSummaryByModel(model: any): string {
        if (!model) return '';
        return (model.personSummaryPrefix ?? '') + model.name + ' ' + model.surname + (model.personSummarySuffix ?? '');
    }
}
